import { render, staticRenderFns } from "./TabCollection.vue?vue&type=template&id=24a0e2ba&scoped=true"
import script from "./TabCollection.vue?vue&type=script&lang=js"
export * from "./TabCollection.vue?vue&type=script&lang=js"
import style0 from "./TabCollection.vue?vue&type=style&index=0&id=24a0e2ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a0e2ba",
  null
  
)

export default component.exports